import useIsMobile from './hooks/useIsMobile';
import DownloadCardWeb from './DownloadCardWeb';
import DownloadCardMobile from './DownloadCardMobile';

// DownloadCard Component
const DownloadCard = ({ platform, qrSrc, badgeHeight, platformText = "Tap or Scan to Download the App" }) => {
    const isMobile = useIsMobile();

    return (
        <>
            {isMobile ? (
                <DownloadCardMobile
                    platform={platform}
                    qrSrc={qrSrc}
                    badgeHeight={badgeHeight}
                    platformText={platformText}
                />
            ) : (
                <DownloadCardWeb
                    platform={platform}
                    qrSrc={qrSrc}
                    badgeHeight={badgeHeight}
                    platformText={platformText}
                />
            )}
        </>
    );
};

export default DownloadCard;